<template>
	<div class="relative">
		<div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
			<Search class="h-5 w-5 text-gray-400 dark:text-gray-500 z-10" />
		</div>
		<input
		:value="modelValue"
		@input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
		type="text"
		:placeholder="placeholder"
		class="input pl-10"
		:class="{ 'input-error': hasError }"
		/>
	</div>
</template>

<script setup lang="ts">
import { Search } from 'lucide-vue-next'

defineProps<{
	modelValue: string
	placeholder?: string
	hasError?: boolean
}>()

defineEmits<{
  	(e: 'update:modelValue', value: string): void
}>()
</script>
